import React, { useState, useEffect } from 'react';
import { forumApi } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

const REACTIONS = [
  { key: 'thumbsup', emoji: '👍', label: 'Thumbs Up' },
  { key: 'fire', emoji: '🔥', label: 'Fire' },
  { key: 'checkered_flag', emoji: '🏁', label: 'Checkered Flag' },
];

export default function EmojiReactions({ targetType, targetId }) {
  const { user } = useAuth();
  const [counts, setCounts] = useState({});
  const [userReactions, setUserReactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchReactions = async () => {
      try {
        const res = await forumApi.getReactions(targetType, targetId);
        setCounts(res.data.counts || {});
        setUserReactions(res.data.user_reactions || []);
      } catch (e) {
        // Reaction fetch is non-critical (target may have no reactions yet)
        console.debug(`No reactions for ${targetType}/${targetId}`, e?.message);
      }
    };
    fetchReactions();
  }, [targetType, targetId]);

  const handleReact = async (reaction) => {
    if (!user || loading) return;
    setLoading(true);
    try {
      const res = await forumApi.react(targetType, targetId, reaction);
      setCounts(res.data.counts || {});
      setUserReactions(res.data.user_reactions || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-1.5 mt-3">
      {REACTIONS.map(({ key, emoji, label }) => {
        const count = counts[key] || 0;
        const active = userReactions.includes(key);
        return (
          <button
            key={key}
            onClick={() => handleReact(key)}
            disabled={!user || loading}
            title={user ? label : 'Login to react'}
            data-testid={`react-${key}-${targetId}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm transition-all border ${
              active
                ? 'bg-[#FF3B30]/15 border-[#FF3B30]/40 text-white'
                : 'bg-[#1F1F1F] border-[#262626] text-gray-400 hover:border-[#FF3B30]/30 hover:text-white'
            } ${!user ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          >
            <span className="text-base leading-none">{emoji}</span>
            {count > 0 && <span className="font-medium text-xs">{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
